/** use for Scayle checkout. See - src/app/[locale]/(checkout)/checkout/page.tsx */
export const HEADER_ID = 'headerid';
export const HEADER_LINE_ID = 'header-line-id';
export const DAILY_DEAL_PRODUCT_LABEL = 'TAGESTIPP';
export const DAILY_DEAL_PRODUCT_BADGE_URL =
  'https://a.storyblok.com/f/275783/200x50/d6d84ba9d0/tagestipp.gif';
export const FREE_PRODUCT_LABEL = 'KOSTENLOS';
export const MIN_FREE_SUBTOTAL = 495; // 4.95
export const PRICE_PROMOTION_KEY = 'dailydeal'; // default key for daily deals
export const PACKSTATION_TYPE = 'locker';
export const GIFT_CARD_CATEGORY = 'Digital Products';

export enum GENDER {
  MALE = 'm',
  FEMALE = 'f',
  COMPANY = 'd',
  UNKNOWN = 'n',
}

export enum SHOP_LOCALES {
  NL = 'NL',
  BE = 'BE',
}
